import axios from '@/shared/axios';
import { ThreadsPostDetailModelV1, ThreadsPostListModelV1 } from '@/types/threads';
import { BaseResponse } from '@/types/web.interface';

// /threads/post_detail/{postCode}
export async function getThreadsPostDetail(postCode: string) {
  const res = await axios.get<BaseResponse<ThreadsPostDetailModelV1>>(`/threads/post_detail/${postCode}`, {});
  return res.data;
}

// /threads/{username}/user_post
export async function getThreadsUserPostList(username: string, query: { existCode: string }) {
  const res = await axios.get<BaseResponse<ThreadsPostListModelV1>>(`/threads/${username}/user_post`, {
    params: query,
  });
  return res.data;
}
